<!-- Más de una imagen → carrusel -->
<ng-container *ngIf="!isLoading && imagenes.length > 0; else noImgs">
  <div class="carousel-wrapper" [ngClass]="{ 'with-thumbs': !showThumbs }">
    <!-- Carrusel principal -->
    <swiper-container
      class="main-swiper"
      thumbs-swiper=".thumbs-swiper"
      slides-per-view="1"
      [attr.navigation]="!showThumbs ? 'true' : null"
      [attr.pagination]="!showThumbs ? 'true' : null"
      autoplay-delay="3000"
      autoplay-disable-on-interaction="false">
      <swiper-slide *ngFor="let imagen of imagenes; let i = index">
        <div class="image-wrapper" (click)="onImageClick(imagen, i)">
          <img
            [src]="'data:image/jpeg;base64,' + imagen.imageData"
            class="carousel-img"
            alt="Imagen propiedad"
          />
          <div class="image-overlay" *ngIf="showThumbs">
            <i class="fas fa-search-plus"></i>
          </div>
        </div>
      </swiper-slide>
    </swiper-container>

    <!-- Thumbnails -->
    <swiper-container
      class="thumbs-swiper"
      *ngIf="showThumbs"
      [attr.direction]="isMobile ? 'horizontal' : 'vertical'"
      [attr.slides-per-view]="isMobile ? 4 : 'auto'"
      space-between="8"
      free-mode="true"
      watch-slides-progress="true"
    >
      <swiper-slide *ngFor="let imagen of imagenes">
        <img
          [src]="'data:image/jpeg;base64,' + imagen.thumbnail"
          class="thumb-img"
          alt="Miniatura"
        />
      </swiper-slide>
    </swiper-container>
  </div>
</ng-container>

<!-- Una sola imagen o ninguna -->
<ng-template #singleOrNoImg>
  <div class="carousel-wrapper">
    <div class="main-swiper">
      <!-- Una sola imagen -->
      <img
        *ngIf="imagenes.length === 1; else noImgs"
        class="carousel-img"
        [src]="'data:image/jpeg;base64,' + imagenes[0].imageData"
        alt="Imagen propiedad"
      />
    </div>
  </div>
</ng-template>

<!-- Sin imágenes -->
<ng-template #noImgs>
  <div class="carousel-wrapper">
    <div class="main-swiper">
      <img class="carousel-img" [src]="'' | noimage" alt="Sin Imagen" />
    </div>
  </div>
</ng-template>
